import { Helmet } from 'react-helmet';
import { StaffEditContainer } from '../components/staff-edit.container';


export const StaffEdit: React.FC = () => {

  return (
    <>
      <Helmet>
        <title>Staff Edit</title>
      </Helmet>
      <StaffEditContainer />
    </>
  );
};
